package com.eladfinish.bible.contest.ui.animations

import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import com.eladfinish.bible.contest.screens.randomVerse.ui.AnimationState

/**
 * Returns a [Modifier] that applies a scale pop-in animation (0.1 → 1.0, 500ms).
 * Triggers once per [key] change; pass [enabled] = false to skip.
 */
@Composable
fun rememberPopInModifier(key: Any?, enabled: Boolean = true): Modifier {
    var animationState by remember {
        mutableStateOf(if (enabled) AnimationState.OFF else AnimationState.IDLE)
    }
    val scaleModifier = rememberScaleAnimation(
        animationState = animationState,
        resetScaleAnimation = { animationState = AnimationState.IDLE },
    )
    LaunchedEffect(key) {
        if (enabled) animationState = AnimationState.RUNNING
    }
    return scaleModifier
}

@Composable
internal fun rememberScaleAnimation(
    animationState: AnimationState,
    resetScaleAnimation: () -> Unit,
): Modifier {
    val scale by animateFloatAsState(
        targetValue = if (animationState == AnimationState.OFF) 0.1f else 1f,
        animationSpec = tween(
            durationMillis = if (animationState == AnimationState.OFF) 0 else 500,
            easing = FastOutSlowInEasing,
        ),
        finishedListener = {
            resetScaleAnimation()
        }
    )

    return Modifier.scale(
        scaleX = scale,
        scaleY = 1f,
    )
}
